export const SUCCESS_DEFAULT = 'neo-trading/auth/SUCCESS_DEFAULT';
export const FAILURE_DEFAULT = 'neo-trading/auth/FAILURE_DEFAULT';
const LOADING_ON = 'neo-trading/auth/LOADING_ON';
const LOADING_OFF = 'neo-trading/auth/LOADING_OFF';
const LOAD = 'neo-trading/auth/LOAD';
const LOAD_SUCCESS = 'neo-trading/auth/LOAD_SUCCESS';
const CHANGE ='neo-trading/auth/CHANGE';
const LOAD_FAIL = 'neo-trading/auth/LOAD_FAILURE';
const LOGIN = 'neo-trading/auth/LOGIN';
const LOGIN_SUCCESS = 'neo-trading/auth/LOGIN_SUCCESS';
const LOGIN_FAIL = 'neo-trading/auth/LOGIN_FAILURE';
const LOGOUT = 'neo-trading/auth/LOGOUT'; // Uncomment this upon connecting with logout api
const LOGOUT_SUCCESS = 'neo-trading/auth/LOGOUT_SUCCESS';
const LOGOUT_FAIL = 'neo-trading/auth/LOGOUT_FAILURE';// Uncomment this upon connecting with logout api
const ACCEPT='neo-trading/auth/ACCEPT';
const ACCEPT_SUCCESS='neo-trading/auth/ACCEPT_SUCCESS';
const ACCEPT_FAIL='neo-trading/auth/ACCEPT_FAILURE';
const DECLINE='neo-trading/auth/DECLINE';
const DECLINE_SUCCESS='neo-trading/auth/DECLINE_SUCCESS';
const DECLINE_FAIL='neo-trading/auth/DECLINE_FAILURE';
const HANDLE_SESSION = 'neo-trading/auth/HANDLE_SESSION';
const KILL_LOGOUT = 'neo-trading/auth/KILL_LOGOUT';// Uncomment this upon connecting with logout api
const LOAD_CHANGE_PASSWORD_SUCCESS='neo-trading/dashboard/LOAD_CHANGE_PASSWORD_SUCCESS';
const RESETPASS_FLAG='neo-trading/auth/RESETPASS_FLAG';
const FORCED_LOGOUT_CLOSED='neo-trading/auth/FORCED_LOGOUT_CLOSED';
export const SAVE_SETTING='neo-trading/auth/SAVE_SETTING';
export const SAVE_SETTING_SUCCESS='neo-trading/auth/SAVE_SETTING_SUCCESS';
export const SAVE_SETTING_FAILURE='neo-trading/auth/SAVE_SETTING_FAILURE';
export const TRD_SETTING_CHANGED='neo-trading/auth/TRD_SETTING_CHANGED';
export const CONFIG_SETTING='neo-trading/auth/CONFIG_SETTING';
export const CONFIG_SETTING_SUCCESS='neo-trading/auth/CONFIG_SETTING_SUCCESS';
export const CONFIG_SETTING_FAIL='neo-trading/auth/CONFIG_SETTING_FAILURE';
export const UPDATE_SHOWPRICE='neo-trading/auth/UPDATE_SHOWPRICE';
export const TRADING_DISABLE='neo-trading/auth/TRADING_DISABLE';
export const ACC_CHANGE='neo-trading/auth/ACC_CHANGE';
export const HIDE_PASSEXP_MSG= 'neo-trading/hidePswrdExpPopup/HIDE_PASSEXP_MSG'
export const HIDE_PASSEXP_MSG_SUCCESS= 'neo-trading/hidePswrdExpPopup/HIDE_PASSEXP_MSG_SUCCESS'
export const HIDE_PASSEXP_MSG_FAILURE= 'neo-trading/hidePswrdExpPopup/HIDE_PASSEXP_MSG_FAILURE'
export const RESET_PASS_STATUS='neo-trading/RESET_PASS_STATUS'
export const CHANGE_RESET_PASSWORD_STATUS = 'neo-trading/CHANGE_RESET_PASSWORD_STATUS'
export const UPDATE_ACD_DATA = 'neo-trading/UPDATE_ACCOUNT_DATA'
import config from './../../config';
import moment from 'moment';
// const LOAD_CHANGE_PASSWORD ='neo-trading/auth/LOAD_CHANGE_PASSWORD';
//const LOAD_CHANGE_PASSWORD_FAILURE ='neo-trading/auth/LOAD_CHANGE_PASSWORD_FAILURE';
const initialState = {
  loading: false,
  loaded: false,
  userDetail:null,
  userSession:null,
  accBal:null,
  showRP:false,
  logoutSuccess:true,
  forcedLogin:false,
  loaderFlag:false,
  loggingIn:false,
  allowLMT_PF:false,
  userProfileFlag:false,
  loginStatus:false,
  changePassword:false,
  selectedTheme:'SB',
  configInfo:'',
  loginTime:'',
  disableOrdModify:false,
  errorMsg:'',
  ShowPwdExpMsg: false,
  PwdExpCount:'',
  resetPasswordStatus:''
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOADING_ON:
      return {
        ...state,
        loading: true,
      };
    case LOADING_OFF:
      return {
        ...state,
        loading: false,
      };
    case SUCCESS_DEFAULT:
      return {
        ...state,
      };
    case FAILURE_DEFAULT:
      return {
        ...state,
      };
    case LOAD:
      return {
        ...state,
      };
    case CONFIG_SETTING:
      return {
        ...state,
        configInfo:''
      };
    case CONFIG_SETTING_SUCCESS:
    return {
      ...state,
      configInfo:action.result.dataObject
    };
    case CONFIG_SETTING_FAIL:
    return {
      ...state,
      configInfo:''
    };
    case LOAD_SUCCESS:
      return {
        ...state,
        loaded: true,
        user: action.result
      };
    case LOAD_FAIL:
      return {
        ...state,
        loaded: false,
        error: action.error
      };
    case LOGIN:
      return {
        ...state,
        loggingIn: true,
        loaderFlag:false,
        loginStatus:true,
        errorMsg:''
      };
    case LOGIN_SUCCESS:
 	   localStorage.setItem('ver', Math.random());
       localStorage.setItem('backButtonFlag','false');
       localStorage.setItem('logoutClose','false');
       localStorage.setItem('windowForcedLogin','false');
       localStorage.setItem("MsgSqNo",0);
        if(!action.result.dataObject.RP && !action.result.dataObject.ShowPwdExpMsg){
          localStorage.setItem('userlogin', 'true');
        }
       const msg = action.result.errCode;
       const errorMsg = errorMessage(msg);
       var temp=[""];
       var obj={'array':temp};
       localStorage.setItem('trdPnlCmdty',JSON.stringify(obj));
      setDCO(action.result.dataObject);
      setTCO(action.result.dataObject);
       return {
         ...state,
         ACD:setAccountDetail(action.result.dataObject),
         DFA:JSON.parse(localStorage.getItem("DFA")),
         loaded: true,
         loggingIn: true,
         userDetail: setUserDetail(action.result.dataObject),
         userSession:setUserSession(action.user,action.result.dataObject,state.configInfo),
         forcedLogin:false,
		     logoutSuccess: false,
         showRP:action.result.dataObject.RP,
         errorMsg:errorMsg,
         loaderFlag:true,
         allowLMT_PF:false,//action.result.dataObject.EPartFill
         loginStatus:true,
         selectedTheme:action.result.dataObject.selectedTheme?action.result.dataObject.selectedTheme:"SB",
         configInfo:setConfigInfo(action.user,state.configInfo),
         loginTime:moment(new Date()).format('DD-MMM-YYYY HH:mm:ss'),
         disableOrdModify:action.result.dataObject.disableOrdModify?action.result.dataObject.disableOrdModify:false,
         PwdExpCount:action.result.dataObject.PwdExpCount,
         ShowPwdExpMsg:action.result.dataObject.ShowPwdExpMsg
       };
      case LOGIN_FAIL:
        if(action.result?.errCode===203){
            return{
              ...state,
              forcedLogin:true,
              forceUser:action.result.dataObject.user,
              forcepwd:action.result.dataObject.pwd,
              loaded: false,
              loggingIn: false,
              errorMsg:errorMessage(action.result.errCode),
              loaderFlag:true,
              loginStatus:false,
            };
        }else {
        return {
              ...state,
              forcedLogin:false,
              message: action.result?.message,
              loaded: false,
              loggingIn: false,
              errorMsg:errorMessage(action.result?.errCode),
              error: action.result ? action.result.data : '',
              loaderFlag:false,
              loginStatus:false,
            };
        }
    // Uncomment if there is logout api
    case LOGOUT:
      return {
        ...state,
        loginStatus:false,
      };
    case LOGOUT_SUCCESS:
    	localStorage.setItem('user', null);
      localStorage.setItem('userAuthToken', null);
      localStorage.setItem('userlogin', null);
      localStorage.setItem('userDetail', null);
      localStorage.setItem('DFA', JSON.stringify([]));
      localStorage.setItem('DCO', JSON.stringify([]));
      localStorage.setItem('TCO', JSON.stringify([]));
        return {
        ...state,
        message: action.result.message,
        logoutSuccess: true,
        userSession:null,
        showRP:false,
        loaderFlag:false,
        loginStatus:false,
        ShowPwdExpMsg:false
      };
    case KILL_LOGOUT:
      localStorage.setItem('user', null);
      localStorage.setItem('userAuthToken', null);
      return {
      ...state,
      user: null,
      logoutSuccess: true,
      loaderFlag:false,
      loginStatus:false,
      ShowPwdExpMsg:false
    };
    case UPDATE_SHOWPRICE:
      return {
        ...state,
        userDetail: updateUserdetail(state.userDetail,action.message)
      };
    // Uncomment if there is logout api
    case LOGOUT_FAIL:
      return {
        ...state,
        logoutError: action.error,
      };
    case HANDLE_SESSION:
      return {
        ...state,
        logoutSuccess: true
      };
    case  LOAD_CHANGE_PASSWORD_SUCCESS:
	  return{
      ...state,
      showRP:action.data,
      user: null,
      message:action.error ? action.message : "Reset Password",
      logoutSuccess: true,
      loginStatus:false,
      changePassword:true,
      resetPasswordStatus:'success'
    };
    case RESET_PASS_STATUS:
      return{
        ...state,
        resetPasswordStatus:'initiated'
      }
    case FORCED_LOGOUT_CLOSED:
      return{
        ...state,
        forcedLogin:false,
        loginStatus:false,
      }
    case RESETPASS_FLAG:
     localStorage.setItem('userlogin', null);
    return{
      ...state,
      user:null,
      showRP:false,
      loginStatus:false
    };
    case SAVE_SETTING:
    return{
      ...state,
    };
    case SAVE_SETTING_SUCCESS:
     return{
       ...state,
       userDetail:updateUserSett(state.userDetail,action.obj,action.result.dataObject),
       DFA:setDefaultAccountDetail(state.ACD,action.result.dataObject),
       ACD:updateAccountDetail(state.ACD,action.result.dataObject),
       userProfileFlag:false,
       selectedTheme:JSON.parse(action.result.dataObject.trdStt).selectedTheme
     };
    break;
    case SAVE_SETTING_FAILURE:
    return{
      ...state,
    };
    case TRD_SETTING_CHANGED:
    localStorage.setItem('user', null);
    localStorage.setItem('userAuthToken', null);
    localStorage.setItem('userlogin', null);
    localStorage.setItem('userDetail', null);
    localStorage.setItem('DFA', JSON.stringify([]));
    localStorage.setItem('DCO', JSON.stringify([]));
    localStorage.setItem('TCO', JSON.stringify([]));
      return {
      ...state,
      logoutSuccess: true,
      userSession:null,
      showRP:false,
      loaderFlag:false,
      loginStatus:false,
    };
    case TRADING_DISABLE:
      return {
        ...state,
        userDetail: updateCanTrade(state.userDetail,action.message)
      };
    case ACC_CHANGE:
      return {
        ...state,
        DFA: updateDefaultAccountDetail(state.ACD,action.message),
        ACD:updateAccountDetail(state.ACD,action.message)
      };

    case HIDE_PASSEXP_MSG:
    case HIDE_PASSEXP_MSG_FAILURE:
    case HIDE_PASSEXP_MSG_SUCCESS:
      return{
        ...state,
      };
    case CHANGE_RESET_PASSWORD_STATUS:
      return{
        ...state,
        ShowPwdExpMsg: false,
        showRP: false,
        resetPasswordStatus: ''
      };
    case UPDATE_ACD_DATA: 
      return {
        ...state,
        ACD: updateAcdData(state.ACD, action.message),
        DFA: updateDFA(state.DFA, action.message)
      }
    default:
      return state;
  }
}

export function updateDFA(dfa, bcmData) {
  let dfaCopy = { ...dfa };
  if (bcmData.AC === dfaCopy.C) {
    dfaCopy = {
      ...dfaCopy,
      D: bcmData.ACD,
      MT: bcmData.RC,
      isActiveAcc: bcmData.IAC,
    };
  }
  localStorage.setItem("DFA", JSON.stringify(dfaCopy));
  return dfaCopy;
}
export function updateAcdData(acdDataMap, bcmData) {
  const acdDataMapCopy = new Map(acdDataMap)
  const account = acdDataMapCopy.get(bcmData.AC);
  if (account) {
    const updatedAccountData = {
      ...account,
      C: bcmData.AC,
      D: bcmData.ACD,
      DSS: bcmData.DSS,
      MT: bcmData.RC,
      isActiveAcc: bcmData.IAC,
    };
    acdDataMapCopy.set(bcmData.AC, updatedAccountData);
  }
  const acdDataMapArray = Array.from(acdDataMapCopy)
  localStorage.setItem('ACD',JSON.stringify(acdDataMapArray));
  return acdDataMapCopy;
}

export function isLoaded(globalState) {
  return globalState.auth && globalState.auth.loaded;
}
export function resetpass_flag(){
   localStorage.setItem('TC',"false");
  return{
    type:RESETPASS_FLAG,
  };
}
/**
 * Actytion to fetch current user data.
 */
export function load() {
  return {
    type: LOAD_SUCCESS,
    result: {
      status: 'failure',
      authToken: null
    }
  };
}
export function setDCO(detail){
  var dcoMap=new Map();
  JSON.parse(detail.DCO).forEach(function(cmdtId,index) {
    var obj={};
    obj.cmdtId=cmdtId;
      dcoMap.set(cmdtId,obj);
  });
  localStorage.setItem("DCO",JSON.stringify(Array.from(dcoMap.entries())));
}
export function setTCO(detail){
  var tcoMap=new Map();
    JSON.parse(detail.TCO).forEach(function(cmdtId) {
      var obj={};
      obj.cmdtId=cmdtId;
        tcoMap.set(cmdtId,obj);
    });
    localStorage.setItem("TradingInst", detail.TCO);
    localStorage.setItem("DisplayInst", detail.DCO);
    localStorage.setItem("TCO",JSON.stringify(Array.from(tcoMap.entries())));
}
export function updateUserSett(userDetail,data,dataObject){
  try {
    userDetail.isTrdInstant=data.trdSettings.isTrdInstant;
    userDetail.storetradeqty=data.trdSettings.storetradeqty;
    userDetail.showStock=data.trdSettings.showStock;
    userDetail.storetradeqty=data.trdSettings.storetradeqty;
    userDetail.isMarginWithOrders=data.trdSettings.isMarginWithOrders;
    userDetail.LN=data.LN;
    userDetail.fontSize=data.trdSettings.fontSize;
    userDetail.selectedTheme=JSON.parse(dataObject.trdStt).selectedTheme;// console.log(dataObject.trdStt.selectedTheme)
    if (dataObject.showPrice === undefined || dataObject.showPrice === 'undefined') {
      userDetail.showPrice=userDetail.showPrice;
    }else {
      userDetail.showPrice=dataObject.showPrice;
    }
  } catch (e) {
    console.log(e);
  }
  return userDetail;
}
export function updateUserdetail(userDetail,message){
  try {
    let DFA = JSON.parse(localStorage.getItem("DFA"));
    if (userDetail.isMainCompTrd === true) {
      if (message.acc_code === DFA.C) {
        userDetail.showPrice=message.showPrice;
      }
    }else {
      userDetail.showPrice=message.showPrice;
    }
  } catch (e) {
    console.log(""+e);
  }
  return userDetail;
}
export function setAccountDetail(detail){
  var accountMap=new Map();
  try{
  detail.ACD.forEach(
    function(obj){
        accountMap.set(obj.C,obj);
        if(obj.DFA==="1"){
           localStorage.setItem("DFA",JSON.stringify(obj));
        }
    }
  );
}catch(e){console.log(e);}
  let accountMapArray = Array.from(accountMap)
  localStorage.setItem('ACD',JSON.stringify(accountMapArray));
  return accountMap;
}
export function setUserDetail(details){
    var userObj=details;
    delete userObj.DCO;
    delete userObj.TCO;
    delete userObj.ACD;
    const yearList = [
        {
          "FROM_DATE": moment(new Date()).startOf('year').format('DD-MM-YYYY'),  //If yearlist obj didn't receive
          "TO_DATE": moment(new Date()).format('DD-MM-YYYY'),
          "YEAR": "Current Year"
        }
    ] 
    userObj = !userObj.hasOwnProperty('yearList') || (userObj.yearList && !userObj.yearList.length) ? Object.assign(userObj, {yearList: yearList}) : userObj
    localStorage.setItem("userDetail",JSON.stringify(userObj));
    return userObj;
}
export function setUserSession(user,details,configInfo){
    var userSession = {};
    userSession.trdCode=details.traderCode;
    userSession.UID=details.UID;
    userSession.SID=details.SID;
    userSession.UD=details.UD;
    userSession.location=configInfo.showTrdCompanyCode===true?user.location:configInfo.location;
    localStorage.setItem('user',JSON.stringify(userSession));
    return userSession;
}
export function setConfigInfo(user,configInfo){
  configInfo.location=configInfo.showTrdCompanyCode===true?user.location:configInfo.location;
  configInfo.locationDesc=configInfo.showTrdCompanyCode===true?user.locationDesc:configInfo.locationDesc;
  return configInfo;
}
export function login(user) {
  return {
    type: LOGIN,
    user,
    promise: (client) => client.post('/restlogin', {
      data: {
        username: user.name,
        password: user.password,
        location: user.location,
        FL:user.forcedLogin
      }
    })
  };
}

export function handleAcdDataUpdate(bcmMessage) {
  return {
    type: UPDATE_ACD_DATA,
    message: bcmMessage,
  };
}

//Hide Password Expiry Popup
export function hidePassswordExpPopup() {
  return {
    type: HIDE_PASSEXP_MSG,
    promise: (client) => client.get('/hidePswrdExpPopup')
  };
}

export function handleResetPwdStatus() {
  return {
    type: RESET_PASS_STATUS
  };
}

export function changeResetPasswordStatus() {
  return {
    type: CHANGE_RESET_PASSWORD_STATUS
  }
}

/** Use this function to connect with logout api*/
 export function killSeesionlogout() {
 	  return {
 	    type:KILL_LOGOUT
 	  };
 	}
export function logout(userDetail) {
	  return {
	    type: LOGOUT,
	    promise: (client) => client.post('/logoutUser', {

        data:{
          UID:userDetail.UID
        }
      })

	  };
	}

export function showLoadingIndicator() {
  return {
    type: LOADING_ON
  };
}

export function stopLoadingIndicator() {
  return {
    type: LOADING_OFF
  };
}
export function handleSession() {
  return {
    type: HANDLE_SESSION
  };
}

export function setDefaultAccountDetail(ACD,data){
  try {
    const accData=JSON.parse(data.accBal);
    const obj={};
    obj.C=accData.AC;
    obj.D=ACD.get(accData.AC).D;
    obj.DFA=1;
    obj.MT=ACD.get(accData.AC).MT;
    obj.currency=ACD.get(accData.AC).currency;
    obj.DC= ACD.get(accData.AC)?.DC;
    localStorage.setItem("DFA",JSON.stringify(obj));
    return obj;
  } catch (e) {
    console.log("setDefaultAccountDetail "+ e);
  }
}

export function updateCanTrade(userDetail,message){
  let canTrade;
  if(message.TrdST == 0){
    canTrade = false
  }else {
    canTrade = true
  }
  userDetail.canTrade=canTrade;
  return userDetail;
}

export function updateAccountDetail(ACD,data){
  try {
    //const accData=JSON.parse(data.accBal);
    const accDet = Array.from(ACD.values()).map(item => {
      if(data.AC === item.C){
        item.DFA=1;
      }else {
        item.DFA=0;
      }
      const temp= ACD.get(item.C);
      ACD.set(item.C,item)
      return item
    });
    const AcdArray = Array.from(ACD)
    localStorage.setItem("ACD",JSON.stringify(AcdArray));
    return ACD;
  } catch (e) {
    console.log(" updateAccountDetail "+ e);
  }
}

export function updateDefaultAccountDetail(ACD,data){
  try {
    const obj={};
    obj.C=data.AC;
    obj.D=ACD.get(data.AC).D;
    obj.DFA=1;
    obj.MT=ACD.get(data.AC).MT;
    obj.currency=ACD.get(data.AC).currency;
    obj.DC= ACD.get(data.AC)?.DC;
    localStorage.setItem("DFA",JSON.stringify(obj));
    return obj;
  } catch (e) {
    console.log("updateDefaultAccountDetail "+ e);
  }
}

export function errorMessage(msg) {
let errorMsg='';
switch (msg) {
    	case 201:
      // errorMsg = "Invalid Trader Code or Password"  /// Bug no 10550 fix 
      errorMsg="Please enter valid credentials."
      break
      case 202:
      // errorMsg = "Invalid Trader Code or Password" /// Bug no 10550 fix
      errorMsg="Please enter valid credentials."
      break
    	case 203:
    	errorMsg = "Another active session on same platform. Please contact your trading desk."
      break
    	case 204:
      errorMsg = "Invalid Password. Maximum login attempts reached. Password blocked. Please contact your trading desk."
      break
      case 205:
    	errorMsg = "Login blocked. Please contact your trading desk."
      break
      case 206:
      errorMsg = "Invalid Trader Terminal. Please contact your trading desk."
      break
      case 207:
      errorMsg = "Invalid Credentials."
      break
      case 208:
      errorMsg ="No Accounts Linked. Please contact your trading desk."
      break
      case 209:
      errorMsg ="Invalid Password. Your account will get locked, in case of incorrect password in the next attempt."
      break
      case 210:
      errorMsg ="Login Failed."
      break
      case 230:
      case 231:
      errorMsg ="Login has been disabled. Please contact the Trading Desk."
      break
      default:
      errorMsg = "Login Succesful"
      };
      return errorMsg;
  }
  export function closeForceLogout(){
    return {
      type: FORCED_LOGOUT_CLOSED
    };
  }

  export function resetStateLogout(){
    return {
      type: TRD_SETTING_CHANGED
    };
  }
  export function getConfigInfo(url,port){
    return {
      type: CONFIG_SETTING,
      promise: (client) => client.get('/getCompanyInfo', {
        // data: {
        //   url: url,
        //   port: port
        // }
      })
    };
  }
